export default "__VITE_ASSET__dS08RP41__"